/**
 * 计算阅读时间
 * @param text - 要计算阅读时间的文本
 * @param imageCount - 可选参数，文本中包含的图片数量
 * @returns 阅读时间（分钟）
 */
export function getReadTime(text: string, imageCount?: number) {
  // 汉字每分钟阅读量
  const chineseWpm = 300
  // 英文每分钟阅读量
  const englishWpm = 175

  // 计算文本中汉字的数量
  const chineseWordsCount = text.match(/\p{sc=Han}/gu)?.length || 0
  // 计算文本中英文单词的数量
  const englishWordsCount = text
    .replace(/[^\w-]/g, ' ')
    .split(/\s+/)
    .filter((w) => {
      return ['', '-', '_'].indexOf(w.trim()) === -1
    }).length

  // 计算文本的阅读时间
  const time = chineseWordsCount / chineseWpm + englishWordsCount / englishWpm

  let i = 0
  let imageTime = 0
  if (imageCount) {
    // 图片的读取时间修正为第一张 12 秒，第二张 11 秒，依次减少 1 秒到第 10 张之后，每张以 3 秒计算。
    // 有的图片是漫画，时间较长，有的是插图或者美图，时间较短，所以这里做了一个简单的修正。
    while (i < imageCount) {
      const current = 12 - i
      imageTime += current < 3 ? 3 : current
      i++
    }
  }

  // 返回阅读时间（分钟）
  return Math.ceil(time + imageTime / 60)
}
